module.exports = __webpack_public_path__ + "assets/valance-roman-selected.b715be8c.svg";